.fullWidth {
  width: 100%;
}
